import type { TCatalogType } from '@/logic/index/types'

export const HEADER_URL: Record<TCatalogType, string> = {
  agroproducts: '/agricultural-products#category1',
  machinery: '/agricultural-products#category440',
}
